// / import React, { useEffect, useState } from "react";
// import {
//   Card,
//   CardContent,
//   Box,
//   Typography,
//   CircularProgress,
//   Grid,
// } from "@mui/material";
// import { Link } from "react-router-dom"; // Using react-router-dom for navigation
// import { getToken } from "../../utils/utils";
// import { getTasks } from "../../pages/tasks/api";
// import PaginationComponent from "../AssignTask/Pagination";

// interface ChildProps {
//   Totalcount: number;
//   setTotalcount: React.Dispatch<React.SetStateAction<number>>;
//   activecoun: number;
//   setactivecount: React.Dispatch<React.SetStateAction<number>>;
//   pendingcount: number;
//   setpendingcount: React.Dispatch<React.SetStateAction<number>>;
//   completedcount?: number;
//   setcompletedcount?: React.Dispatch<React.SetStateAction<number>>;
// }

// interface Task {
//   task_id: string;
//   taskTitle: string;
//   title: string;
//   tag: string;
//   credit_points: number;
//   createdAt: string;
//   endDate: string;
//   applied_filters: string[];
// }

// const Productcard: React.FC<ChildProps> = ({
//   Totalcount,
//   setTotalcount,
//   activecoun,
//   setactivecount,
//   pendingcount,
//   setpendingcount,
//   completedcount,
//   setcompletedcount,
// }) => {
//   const [tasks, setTasks] = useState<Task[]>([]);
//   const [page, setPage] = useState(1);
//   const [loading, setLoading] = useState(false);
//   const token = getToken();
//   const perpagedata = 10;

//   useEffect(() => {
//     const fetchTasks = async () => {
//       try {
//         setLoading(true);
//         const response = await getTasks(token, page, perpagedata);
//         const paginatedResults = response.data.data.paginatedResults;

//         const mappedTasks = paginatedResults.map((task: any) => {
//           const date = new Date(task.createdAt);
//           const day = date.getDate();
//           const suffix =
//             day % 10 === 1 && day !== 11
//               ? "st"
//               : day % 10 === 2 && day !== 12
//               ? "nd"
//               : day % 10 === 3 && day !== 13
//               ? "rd"
//               : "th";
//           const month = date.toLocaleString("en-US", { month: "short" });
//           const year = date.getFullYear();
//           const formattedDate = `${day}${suffix} ${month} ${year}, ${date.getHours()}:${date.getMinutes()}`;

//           return {
//             task_id: task.task_id,
//             taskTitle: task.task_type_en,
//             title: task.task_en,
//             tag: task.main_task_status,
//             credit_points: task.credit_points || 0,
//             createdAt: formattedDate,
//             endDate: task.end_date,
//             applied_filters: task.applied_filters || [],
//           };
//         });

//         setTasks(mappedTasks);
//         setTotalcount(response.data.data.total_users ?? 0);
//         setpendingcount(response.data?.data?.pendingCount ?? 0);
//         setactivecount(response.data?.data?.activetask_count ?? 0);
//         if (setcompletedcount) {
//           setcompletedcount(response.data?.data?.finalcompletedcount ?? 0);
//         }
//         setLoading(false);
//       } catch (error) {
//         console.error("Error fetching tasks:", error);
//         setLoading(false);
//       }
//     };

//     fetchTasks();
//   }, [token, page, setTotalcount, setpendingcount, setactivecount, setcompletedcount]);

//   const totalPages = Math.ceil(Totalcount / perpagedata);

//   const handleLinkClick = (e: React.MouseEvent) => {
//     e.stopPropagation(); // Prevent card's onClick from triggering
//   };

//   return (
//     <Box sx={{ padding: "0 32px" }}>
//       <Grid container spacing={2} sx={{ marginTop: "24px" }}>
//         {loading ? (
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               height: "200px",
//               width: "100%",
//             }}
//           >
//             <CircularProgress />
//           </Box>
//         ) : (
//           tasks.map((task) => (
//             <Grid key={task.task_id} item xs={12}  sm={6} md={4}>
//               <Card
//                 sx={{
//                   maxWidth: "100%",
//                   margin: 2,
//                   border: "1px solid rgba(0, 0, 0, 0.12)",
//                   boxShadow: "none",
//                   borderRadius: "10px",
//                   "&:hover": {
//                     boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
//                   },
//                   transition: "box-shadow 0.3s ease, transform 0.3s ease",
//                   cursor: "pointer",
//                 }}
//               >
//                 <CardContent>
//                   <Box
//                     display="flex"
//                     justifyContent="space-between"
//                     alignItems="center"
//                     sx={{
//                       borderBottom: "1px dashed #d0d0d0",
//                       marginBottom: "10px",
//                       paddingBottom: "10px",
//                     }}
//                   >
//                     <Box>
//                       <Typography sx={{ color: "#696A6B", fontSize: "14px" }}>
//                         {task.taskTitle}
//                       </Typography>
//                       <Typography
//                         sx={{ fontSize: "18px", color: "#282829" }}
//                         variant="h6"
//                         fontWeight="bold"
//                       >
//                         {task.title}
//                       </Typography>
//                     </Box>
//                     <Box>
//                       <Typography
//                         sx={{
//                           fontSize: "12px",
//                           color:
//                             task.tag === "1d left"
//                               ? "#BA0516"
//                               : task.tag === "Not Published"
//                               ? "#696A6B"
//                               : "#2E844A",
//                           background:
//                             task.tag === "1d left"
//                               ? "#FFEBEF"
//                               : task.tag === "Not Published"
//                               ? "#E3E3E3"
//                               : "#EBF7E6",
//                           padding: "7px 10px",
//                           borderRadius: "10px",
//                           fontWeight: "600",
//                         }}
//                       >
//                         {task.tag}
//                       </Typography>
//                     </Box>
//                   </Box>

//                   <Typography
//                     variant="body1"
//                     sx={{ color: "#696A6B", fontSize: "14px", marginBottom: "8px" }}
//                   >
//                     Points: <b style={{ color: "#282829" }}>{task.credit_points}</b>
//                   </Typography>
//                   <Typography
//                     variant="body2"
//                     sx={{ color: "#696A6B", fontSize: "14px", marginBottom: "8px" }}
//                   >
//                     Created at: <b style={{ color: "#282829" }}>{task.createdAt}</b>
//                   </Typography>

//                 <Box
//   sx={{
//     display: "flex",
//     alignItems: "center",
//     gap: "16px",
//     justifyContent: "space-between",
//     marginTop: "16px",
//   }}
// >
//   <Link
//     to={`/Admin_approval/${task.task_id}/Educational`}
//     target="_blank"
//     rel="noopener noreferrer"
//     style={{
//       border: "1px solid rgba(200, 23, 47, 1)",
//       borderRadius: "8px",
//       padding: "6px 40px", // Reduced vertical padding to 6px, increased horizontal to 40px for wider buttons
//       color: "rgba(200, 23, 47, 1)",
//       textDecoration: "none",
//       width: "calc(50% - 8px)", // Adjusted width to account for 16px gap
//       textAlign: "center",
//       fontSize: "14px",
//       fontWeight: "500",
//       boxSizing: "border-box",
//       lineHeight: "1.2", // Tighter vertical alignment for shorter height
//     }}
//     onClick={handleLinkClick}
//   >
//     Preview Task
//   </Link>
//   <Link
//     to={`/manage-task/edit-task/${task.task_id}`}
//     target="_blank"
//     rel="noopener noreferrer"
//     style={{
//       border: "1px solid rgba(200, 23, 47, 1)",
//       borderRadius: "8px",
//       padding: "6px 40px", // Reduced vertical padding to 6px, increased horizontal to 40px for wider buttons
//       color: "#FFF",
//       textDecoration: "none",
//       background: "rgba(200, 23, 47, 1)",
//       width: "calc(50% - 8px)", // Adjusted width to account for 16px gap
//       textAlign: "center",
//       fontSize: "14px",
//       fontWeight: "500",
//       boxSizing: "border-box",
//       lineHeight: "1.2", // Tighter vertical alignment for shorter height
//     }}
//     onClick={handleLinkClick}
//   >
//     Edit Task
//   </Link>
// </Box>
//                 </CardContent>
//               </Card>
//             </Grid>
//           ))
//         )}
//       </Grid>

//       {tasks.length > 0 && (
//         <Box sx={{ background: "#fff", margin: "0" }}>
//           <PaginationComponent
//             page={page}
//             limit={perpagedata}
//             totalPages={totalPages}
//             setPage={setPage}
//           />
//         </Box>
//       )}

//       {tasks.length === 0 && !loading && (
//         <Box
//           sx={{
//             background: "#fff",
//             border: "1px solid rgba(224, 224, 224, 1)",
//             borderTop: "none",
//             margin: "0 32px",
//             padding: "16px",
//             textAlign: "center",
//           }}
//         >
//           No data is available
//         </Box>
//       )}
//     </Box>
//   );
// };

// export default Productcard;
import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  CardContent,
  Box,
  Typography,
  CircularProgress,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Button,
  Tooltip,
} from "@mui/material";
import { Link } from "react-router-dom"; // Using react-router-dom for navigation
import { getToken } from "../../utils/utils";
import { approveTask, getTasks } from "../../pages/tasks/api";
import PaginationComponent from "../AssignTask/Pagination";
import CheckIcon from "@mui/icons-material/Check";
import FrameIcon from "../../../src/assests/images/frameIcon.svg";
import CloseIcon from "@mui/icons-material/Close";
import { useAlert } from "../../pages/AlertContext/AlertContext";
import { AxiosError } from "axios";
import { ispubishedchnages } from "../ActiveTask/api";
import SearchIcon from "@mui/icons-material/Search";
// import sorterArrow from "../../../../src/assests/images/SortingArrow.svg";
import sorterArrow from "../../../src/assests/images/SortingArrow.svg";

import { List, ListItemButton, ListItemText } from "@mui/material";

interface ChildProps {
  Totalcount: number;
  setTotalcount: React.Dispatch<React.SetStateAction<number>>;
  activecoun: number;
  setactivecount: React.Dispatch<React.SetStateAction<number>>;
  pendingcount: number;
  setpendingcount: React.Dispatch<React.SetStateAction<number>>;
  completedcount?: number;
  setcompletedcount?: React.Dispatch<React.SetStateAction<number>>;

  schedulecount?: number;
  setschedulecount?: React.Dispatch<React.SetStateAction<number>>;

  rejectedcount?: number;
  setrejectedcount?: React.Dispatch<React.SetStateAction<number>>;
}

interface Task {
  remaining_days: string;
  end_date: string;
  approval_type: string;
  start_date?: string;
  total_accounts: number;
  record_type: string;
  task_id: string;
  taskTitle: string;
  title: string;
  tag: string;
  credit_points: number;
  createdAt: string;
  endDate: string;
  applied_filters: string[];
  is_approved_reqired: string;
}

const Productcard: React.FC<ChildProps> = ({
  Totalcount,
  setTotalcount,
  activecoun,
  setactivecount,
  pendingcount,
  setpendingcount,
  completedcount,
  setcompletedcount,
  schedulecount,
  setschedulecount,
  rejectedcount,
  setrejectedcount,
}) => {
  const [tasks, setTasks] = useState<Task[]>([]);
  const [page, setPage] = useState(1);
  const [sortOption, setSortOption] = useState<"highest" | "lowest" | null>(
    null
  );
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);
  const [loading, setLoading] = useState(false);
  const token = getToken();
  const perpagedata = 10;
  const { showAlert } = useAlert();

  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("asc");

  const handleSortClick = () => {
    setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    // Call your sort function here with the new order
    console.log("Sorting in", sortOrder === "asc" ? "descending" : "ascending");
  };
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);
    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm]);

  useEffect(() => {
    const fetchTasks = async () => {
      try {
        await ispubishedchnages(token);
      } catch (error) {
        console.error("Error fetching published changes:", error);
      }
    };

    fetchTasks();
  }, [token]);
  useEffect(() => {
    const fetchTasks = async () => {
      try {
        setLoading(true);
        const response = await getTasks(
          token,
          page,
          perpagedata,
          debouncedSearchTerm,
          sortOption ? sortOption : ""
        );
        const paginatedResults = response.data.data.paginatedResults;

        const mappedTasks = paginatedResults.map((task: any) => {
          const formatDate = (dateString: string) => {
            const date = new Date(dateString);
            const day = date.getDate();
            const suffix =
              day % 10 === 1 && day !== 11
                ? "st"
                : day % 10 === 2 && day !== 12
                ? "nd"
                : day % 10 === 3 && day !== 13
                ? "rd"
                : "th";
            const month = date.toLocaleString("en-US", { month: "short" });
            const year = date.getFullYear();
            const hours = date.getHours().toString().padStart(2, "0");
            const minutes = date.getMinutes().toString().padStart(2, "0");
            return `${day}${suffix} ${month} ${year}, ${hours}:${minutes}`;
          };

          return {
            task_id: task.task_id,
            taskTitle: task.task_type_en,
            title: task.task_en,
            tag: task.main_task_status,
            credit_points: task.credit_points || 0,
            createdAt: formatDate(task.createdAt),
            start_date: formatDate(task.start_date),
            end_date: formatDate(task.end_date),
            endDate: task.end_date,
            applied_filters: task.applied_filters || [],

            record_type: task.record_type,
            total_accounts: task.total_accounts,
            approval_type: task.approval_type,
            remaining_days: task.remaining_days,
            is_approved_reqired: task.is_approved_reqired,
          };
        });

        setTasks(mappedTasks);
        setTotalcount(response.data.data.total_users ?? 0);
        setpendingcount(response.data?.data?.pendingCount ?? 0);
        setactivecount(response.data?.data?.activetask_count ?? 0);
        setschedulecount?.(response.data?.data?.scheduledCount ?? 0);
        setrejectedcount?.(response.data?.data?.rejectedcount ?? 0);

        if (setcompletedcount) {
          setcompletedcount(response.data?.data?.finalcompletedcount ?? 0);
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching tasks:", error);
        setLoading(false);
      }
    };

    fetchTasks();
  }, [
    token,
    page,
    setTotalcount,
    setpendingcount,
    setactivecount,
    setcompletedcount,
    debouncedSearchTerm,
    sortOption,
  ]);

  const totalPages = Math.ceil(Totalcount / perpagedata);

  const handleLinkClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // ✅ prevents parent onClick (like a card) from firing
    setTimeout(() => {
      window.location.reload(); // ✅ reloads after 100ms
    }, 100);
  };
  const handleApproval = async (task_id: string, approved: boolean) => {
    try {
      const response = await approveTask(token, task_id, approved);

      if (response.status === 200) {
        showAlert(
          `Task ${approved ? "approved" : "rejected"} successfully!`,
          "success"
        );
      } else {
        // If response is not OK but no error thrown
        const message = response.data?.message || "Something went wrong";
        showAlert(message, "error");
      }
    } catch (error) {
      // Handle Axios or normal errors
      let errorMessage = "An error occurred while updating the task";

      if (error instanceof AxiosError) {
        const serverError =
          error.response?.data?.error || error.response?.data?.message;
        if (serverError?.includes("start date and time")) {
          errorMessage =
            "Failed to approve task: Both the start date and time and the end date and time must be in the future.";
        } else {
          errorMessage = serverError || error.message;
        }
      } else if (error instanceof Error) {
        errorMessage = error.message;
      }

      console.error("Error approving/rejecting task:", error);
      showAlert(errorMessage, "error");
    }
  };

  const sortButtonRef = useRef<HTMLButtonElement>(null);
  const popupRef = useRef<HTMLDivElement>(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  console.log(sortOption, "sortOptionsortOption44444");
  // Handle sort popup open/close
  const handleSortButtonClick = () => setIsPopupOpen((prev) => !prev);

  // Handle selection of sort option
  const handleSortSelection = (option: "highest" | "lowest") => {
    setSortOption(option);
    setIsPopupOpen(false);
  };

  console.log(tasks, "taskstasks7888888");
  return (
    <Box
      sx={{
        padding: "0 32px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "24px",
        }}
      >
        <Box>
          <TextField
            required
            placeholder={"Search by Task Name, Task Type"}
            sx={{
              ".MuiOutlinedInput-root": {
                borderRadius: "12px",
                height: "48px",
                width: "521px",
                "@media (max-width:1366px)": {
                  width: "400px",
                },
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </Box>

        <Box sx={{ position: "relative" }}>
          <Button
            ref={sortButtonRef}
            onClick={handleSortButtonClick}
            variant="outlined"
            sx={{
              height: "48px",
              borderRadius: "12px",
              minWidth: "200px",
              textTransform: "none",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            Sort By UpdateAt
            <img
              src={sorterArrow}
              alt="Sort Arrow"
              style={{ width: "16px", height: "16px" }}
            />
          </Button>

          {/* Sort Popup */}
          {isPopupOpen && (
            <Box
              ref={popupRef}
              sx={{
                position: "absolute",
                top: "55px",
                right: 0,
                backgroundColor: "#fff",
                border: "1px solid #ccc",
                borderRadius: "8px",
                zIndex: 999,
                width: "200px",
                boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
              }}
            >
              <List>
                <ListItemButton onClick={() => handleSortSelection("highest")}>
                  <ListItemText primary="⬇️ Highest to Lowest" />
                </ListItemButton>
                <ListItemButton onClick={() => handleSortSelection("lowest")}>
                  <ListItemText primary="⬆️ Lowest to Highest" />
                </ListItemButton>
              </List>
            </Box>
          )}
        </Box>
      </Box>
      <Grid container spacing={2} sx={{ marginTop: "24px" }}>
        {loading ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "200px",
              width: "100%",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          tasks.map((task) => (
            <Grid key={task.task_id} item xs={12} sm={6} md={4}>
              <Card
                sx={{
                  maxWidth: "100%",
                  margin: 0,
                  border: "1px solid rgba(0, 0, 0, 0.12)",
                  boxShadow: "none",
                  borderRadius: "10px",
                  "&:hover": {
                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
                  },
                  transition: "box-shadow 0.3s ease, transform 0.3s ease",
                  cursor: "pointer",
                }}
              >
                <CardContent>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{
                      borderBottom: "1px dashed #d0d0d0",
                      marginBottom: "10px",
                      paddingBottom: "10px",
                    }}
                  >
                    <Box>
                      {/* <Typography
                sx={{ color: "#696A6B", fontSize: "14px",}}
              >
                <img src={FrameIcon} alt="FrameIcon" />
               

                </Typography>
                      <Typography sx={{ color: "#696A6B", fontSize: "14px" }}>
                        {task.taskTitle}
                      </Typography>
                      <Typography
                        sx={{ fontSize: "18px", color: "#282829" }}
                        variant="h6"
                        fontWeight="bold"
                      >
                        {task.title}
                      </Typography> */}
                      <Typography
                        sx={{
                          color: "#696A6B",
                          fontSize: "14px",
                          display: "flex",
                        }}
                      >
                        <img src={FrameIcon} alt="FrameIcon" />
                        <Typography sx={{ margin: "0px 10px" }}>
                          {task.taskTitle}
                          <Tooltip title={task.title} arrow>
  <Typography
    sx={{
      fontSize: "18px",
      color: "#282829",
      fontWeight: "bold",
      maxWidth: 150,          // adjust width as needed
      whiteSpace: "nowrap",   // keep text on one line
      overflow: "hidden",     // hide overflow
      textOverflow: "ellipsis", // show "..." if text is too long
      display: "block",
      cursor: "pointer",      // indicates hoverable text
    }}
    variant="h6"
  >
    {task.title}
  </Typography>
</Tooltip>
                        </Typography>
                      </Typography>
                      {/* {task.approval_type === "Required"  && task.record_type==="user_task_mapping" && (
    <Box sx={{ mt: 1, display: "flex", gap: 1 }}>
      <IconButton color="success">
        <CheckIcon />
      </IconButton>
      <IconButton color="error">
        <CloseIcon />
      </IconButton>
    </Box>
  )} */}

        

                    </Box>

<Box>
{task.approval_type === "Required" &&
                        task.record_type === "user_task_mapping" &&
                        task.is_approved_reqired !== null &&
                        task.is_approved_reqired !== "rejected" && (
                          <Box sx={{ mt: 0, display: "flex", gap: 1 }}>
      <Tooltip title="Approve">
        <IconButton
          color="success"
          onClick={() => handleApproval(task.task_id, true)} sx={{padding:'0px 0 5px'}}
        >
          <CheckIcon />
        </IconButton>
      </Tooltip>

      <Tooltip title="Reject">
        <IconButton
          color="error"
          onClick={() => handleApproval(task.task_id, false)} sx={{padding:'0px 0 5px'}}
        >
          <CloseIcon />
        </IconButton>
      </Tooltip>
    </Box>
)}
                    {task.record_type === "user_task_mapping" && (
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "12px",
                            color:
                              task.remaining_days === "Not Published"
                                ? "#696A6B"
                                : "#2E844A",
                            background:
                              task.remaining_days === "Not Published"
                                ? "#E3E3E3"
                                : "#EBF7E6",
                            padding: "7px 10px",
                            borderRadius: "10px",
                            fontWeight: "600",
                          }}
                        >
                          {task.remaining_days}
                        </Typography>
                      </Box>
                    )}
                    </Box>
                  </Box>

                  <Typography
                    variant="body1"
                    sx={{
                      color: "#696A6B",
                      fontSize: "14px",
                      marginBottom: "8px",
                    }}
                  >
                    Credit Points:{" "}
                    <b style={{ color: "#282829" }}>{task.credit_points}</b>
                  </Typography>
                    <Typography
                              variant="body1"
                              sx={{ color: "#696A6B", fontSize: "14px", marginBottom: "8px" }}
                            >
                              Created By: <b style={{ color: "#282829" }}>{"Admin"}</b>
                            </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#696A6B",
                      fontSize: "14px",
                      marginBottom: "8px",
                    }}
                  >
                    Created At:{" "}
                    <b style={{ color: "#282829" }}>{task.createdAt}</b>
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#696A6B",
                      fontSize: "14px",
                      marginBottom: "8px",
                    }}
                  >
                    Task Status: <b style={{ color: "#282829" }}>{task.tag}</b>
                  </Typography>
                  {task.record_type === "user_task_mapping" && (
                    <>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#696A6B",
                          fontSize: "14px",
                          marginBottom: "8px",
                        }}
                      >
                        Total Users:{" "}
                        <b style={{ color: "#282829" }}>
                          {task.total_accounts}
                        </b>
                      </Typography>

                      <Typography
                        variant="body2"
                        sx={{
                          color: "#696A6B",
                          fontSize: "14px",
                          marginBottom: "8px",
                        }}
                      >
                        Assigned Date:{" "}
                        <b style={{ color: "#282829" }}>{task.start_date}</b>
                      </Typography>

                      <Typography
                        variant="body2"
                        sx={{
                          color: "#696A6B",
                          fontSize: "14px",
                          marginBottom: "8px",
                        }}
                      >
                        End Date:{" "}
                        <b style={{ color: "#282829" }}>{task.end_date}</b>
                      </Typography>
                    </>
                  )}

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "16px",
                      marginTop: "16px",
                    }}
                  >
                    <Link
                      to={`/Admin_approval/${task.task_id}/Educational`}
                      // target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        border: "1px solid rgba(200, 23, 47, 1)",
                        borderRadius: "8px",
                        padding: "6px 40px", // Reduced vertical padding to 6px, increased horizontal to 40px for wider buttons
                        color: "rgba(200, 23, 47, 1)",
                        textDecoration: "none",
                        textAlign: "center",
                        fontSize: "14px",
                        fontWeight: "500",
                        boxSizing: "border-box",
                        lineHeight: "1.2", // Tighter vertical alignment for shorter height
                        flex: 1, // Use flex to grow equally and handle alignment dynamically
                      }}
                      onClick={handleLinkClick}
                    >
                      Preview Task
                    </Link>
                    <Link
                      to={`/manage-task/edit-task/${task.task_id}`}
                      // target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        border: "1px solid rgba(200, 23, 47, 1)",
                        borderRadius: "8px",
                        padding: "6px 40px", // Reduced vertical padding to 6px, increased horizontal to 40px for wider buttons
                        color: "#FFF",
                        textDecoration: "none",
                        background: "rgba(200, 23, 47, 1)",
                        textAlign: "center",
                        fontSize: "14px",
                        fontWeight: "500",
                        boxSizing: "border-box",
                        lineHeight: "1.2", // Tighter vertical alignment for shorter height
                        flex: 1, // Use flex to grow equally and handle alignment dynamically
                      }}
                      onClick={handleLinkClick}
                    >
                      Edit Task
                    </Link>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))
        )}
      </Grid>

      {tasks.length > 0 && (
        <Box sx={{ background: "#fff", margin: "0" }}>
          <PaginationComponent
            page={page}
            limit={perpagedata}
            totalPages={totalPages}
            setPage={setPage}
          />
        </Box>
      )}

      {tasks.length === 0 && !loading && (
        <Box
          sx={{
            background: "#fff",
            border: "1px solid rgba(224, 224, 224, 1)",
            borderTop: "none",
            margin: "0 32px",
            padding: "16px",
            textAlign: "center",
          }}
        >
          No data is available
        </Box>
      )}
    </Box>
  );
};

export default Productcard;